"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createUtilityPlugin;

var _fromPairs = _interopRequireDefault(require("lodash/fromPairs"));

var _toPairs = _interopRequireDefault(require("lodash/toPairs"));

var _castArray = _interopRequireDefault(require("lodash/castArray"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function className(classPrefix, key) {
  if (key === 'default') {
    return classPrefix;
  }

  if (key.startsWith('-')) {
    return "-".concat(classPrefix).concat(key);
  }

  return "".concat(classPrefix, "-").concat(key);
}

function createUtilityPlugin(themeKey, utilityVariations) {
  return function (_ref) {
    var e = _ref.e,
        addUtilities = _ref.addUtilities,
        variants = _ref.variants,
        theme = _ref.theme;
    var utilities = utilityVariations.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          classPrefix = _ref3[0],
          properties = _ref3[1];

      return (0, _fromPairs.default)((0, _toPairs.default)(theme(themeKey)).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        return [".".concat(e(className(classPrefix, key))), (0, _fromPairs.default)((0, _castArray.default)(properties).map(function (property) {
          return [property, value];
        }))];
      }));
    });
    return addUtilities(utilities, variants(themeKey));
  };
}